// import "…/src/jets/crud"
//= require jquery
//= require jquery-ui
//= require jquery-ui/widget
//= require jquery-ui/sortable


require("trix")
require("@rails/actiontext")